import React, { useState } from "react";
import { IconType } from "react-icons";
import './CheckboxCard.scss';

type CheckboxCardProps = {
    className?: string,
    label: string,
    labelActive?: string,
    icon: IconType,
    disabled?: boolean,
    active?: boolean,
    onChange?: (value: boolean) => void,
};

function CheckboxCard(props: CheckboxCardProps) {
    const handleClick = () => {
        if(props.disabled) {
            return;
        }

        const newValue: boolean = !props.active;
        if(props.onChange) {
            props.onChange(newValue);
        }
    };

    return (
        <div onClick={handleClick} className={`checkboxcard-container ${props.className ?? ''} ${props.disabled ? 'disabled' : ''} ${props.active ? 'active' : ''}`}>
            <div className="checkboxcard-icon">{React.createElement(props.icon, { size: '1.3rem' })}</div>
            <div className="checkboxcard-label">{props.active && props.labelActive ? props.labelActive : props.label}</div>
        </div>
    );
}

export default CheckboxCard;
